var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import { DEFAULT_CURRENCY } from '../../utils/currency';
import cloneDeep from 'lodash/cloneDeep';
export var priceBuilder = function (amount, currency) {
    if (amount === void 0) { amount = '0'; }
    if (currency === void 0) { currency = 'sek'; }
    var formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
    });
    var priceString = formatter.format(parseFloat(amount) / 100).toString();
    priceString = priceString.replace(/[^0-9.,]+/, '');
    return priceString.trim();
};
export var getIncludedCapabilities = function (devPlan) {
    var _a, _b;
    if (devPlan === null || devPlan === void 0 ? void 0 : devPlan.bundles_with_prices) {
        var final_price = (_a = devPlan.bundles_with_prices) === null || _a === void 0 ? void 0 : _a.map(function (price) {
            return __assign(__assign({}, price.final_price), { qty: price.quantity });
        });
        var result = (_b = devPlan.bundles_with_prices) === null || _b === void 0 ? void 0 : _b.map(function (item) {
            return {
                android: item.bundle.meta.android * item.quantity || 0,
                ios: item.bundle.meta.ios * item.quantity || 0,
                pwa: item.bundle.meta.pwa * item.quantity || 0,
                apps: item.bundle.meta.apps * item.quantity || 0,
            };
        });
        return {
            ios: result.reduce(function (accumulator, current) { return accumulator + current.ios; }, 0),
            apps: result.reduce(function (accumulator, current) { return accumulator + current.apps; }, 0),
            android: result.reduce(function (accumulator, current) { return accumulator + current.android; }, 0),
            pwa: result.reduce(function (accumulator, current) { return accumulator + current.pwa; }, 0),
            cost: final_price.reduce(function (accumulator, current) {
                var _a;
                return accumulator +
                    Number(((_a = current[devPlan.currency || DEFAULT_CURRENCY]) === null || _a === void 0 ? void 0 : _a.amount) * current.qty);
            }, 0),
        };
    }
    return {
        ios: 0,
        apps: 0,
        android: 0,
        pwa: 0,
        cost: 0,
    };
};
export var calculateDateDiff = function (target) {
    return moment
        .duration(moment(target).startOf('day').diff(moment().startOf('day')))
        .asDays();
};
export var actualTrialPeriod = function (trialOnPlan, consumed) {
    if (trialOnPlan === void 0) { trialOnPlan = 0; }
    if (consumed === void 0) { consumed = 0; }
    if (trialOnPlan < consumed)
        return 0;
    return trialOnPlan - consumed;
};
export var getBundlesTotal = function (bundles) {
    if (bundles) {
        var result = bundles === null || bundles === void 0 ? void 0 : bundles.map(function (item) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return {
                android: ((_b = (_a = item.bundle) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.android) * item.quantity || 0,
                ios: ((_d = (_c = item.bundle) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.ios) * item.quantity || 0,
                pwa: ((_f = (_e = item.bundle) === null || _e === void 0 ? void 0 : _e.meta) === null || _f === void 0 ? void 0 : _f.pwa) * item.quantity || 0,
                apps: ((_h = (_g = item.bundle) === null || _g === void 0 ? void 0 : _g.meta) === null || _h === void 0 ? void 0 : _h.apps) * item.quantity || 0,
                cost: (((_k = (((_j = item.final_price) === null || _j === void 0 ? void 0 : _j[item.bundle.currency || DEFAULT_CURRENCY]) || {
                    amount: 0,
                    currency: DEFAULT_CURRENCY,
                })) === null || _k === void 0 ? void 0 : _k.amount) || 0) * item.quantity || 0,
            };
        });
        return {
            ios: result.reduce(function (accumulator, current) { return accumulator + current.ios; }, 0),
            apps: result.reduce(function (accumulator, current) { return accumulator + Number(current.apps); }, 0),
            android: result.reduce(function (accumulator, current) { return accumulator + current.android; }, 0),
            pwa: result.reduce(function (accumulator, current) { return accumulator + current.pwa; }, 0),
            cost: result.reduce(function (accumulator, current) { return accumulator + current.cost; }, 0),
        };
    }
    return {
        ios: 0,
        apps: 0,
        android: 0,
        pwa: 0,
        cost: 0,
    };
};
export var exractAddonsFromActiveBindles = function (activeBundles, activeDeveloperPlanBundles) {
    var addons = [];
    activeBundles === null || activeBundles === void 0 ? void 0 : activeBundles.map(function (ab) {
        var relevantDevPlanBundle = null; //check whether dev plan has that bundle
        activeDeveloperPlanBundles === null || activeDeveloperPlanBundles === void 0 ? void 0 : activeDeveloperPlanBundles.map(function (adb) {
            if (adb.bundle.id === ab.bundle.id) {
                relevantDevPlanBundle = adb;
            }
        });
        if (relevantDevPlanBundle === null) {
            addons.push(ab);
        }
        else {
            //deduct devplan qty from active bundle
            var activeBundleToModify = cloneDeep(ab);
            activeBundleToModify.quantity =
                ab.quantity - (relevantDevPlanBundle === null || relevantDevPlanBundle === void 0 ? void 0 : relevantDevPlanBundle.quantity);
            ab.quantity - (relevantDevPlanBundle === null || relevantDevPlanBundle === void 0 ? void 0 : relevantDevPlanBundle.quantity) > 0 &&
                addons.push(activeBundleToModify);
        }
    });
    return addons;
};
